import type { EnumValueType } from '../../EnumUtils'
import { EnumUtils } from '../../EnumUtils'

/**
 * 售后动作常量
 */
export const AfterSaleActionConstants = {
  SUBMIT_APPLICATION: {
    value: 1,
    label: '提交申请',
  },
  AUDIT_APPROVAL: {
    value: 2,
    label: '审核通过',
  },
  PLACE_ORDER: {
    value: 3,
    label: '下单成功',
  },
  ORDER_CONFIRMED: {
    value: 4,
    label: '已确认订单',
  },
  TAKEN: {
    value: 5,
    label: '已拿货',
  },
  CONFIRM_REFUND: {
    value: 6,
    label: '确认退款',
  },
  SUPPLIER_APPROVED: {
    value: 7,
    label: 'S端申请并通过',
  },
} as const

export type AfterSaleActionValue = EnumValueType<typeof AfterSaleActionConstants>

export const afterSaleActionEnumUtils = new EnumUtils<AfterSaleActionValue>(AfterSaleActionConstants)

export default afterSaleActionEnumUtils
